import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import styled from '@emotion/styled';
import {
  useEffect, useRef, useState,
} from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

interface Props {
    fileUrl: string;
    onLoad?: (numPages: number) => void;
}

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();

function PdfViewer({ fileUrl, onLoad }: Props) {
  const [numPages, setNumPages] = useState<number>(0);
  const [width, setWidth] = useState<number>(0);
  const ref = useRef<HTMLDivElement>(null);
  const [loadCount, setLoadCount] = useState<number>(0);
  useEffect(() => {
    const onResize = () => {
      if (ref.current) {
        setWidth(ref.current.clientWidth);
      }
    };
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  useEffect(() => {
    onLoad?.(loadCount);
  }, [loadCount]);

  return (
        <Wrapper ref={ref}>
            <Document
                loading='파일을 불러오는 중입니다.'
                file={fileUrl}
                onLoadSuccess={(v) => {
                  setNumPages(v.numPages);
                }} >
                {Array.from({ length: numPages }).map((_, page) => (
                    <Page
                        onLoadSuccess={() => setLoadCount((prev) => prev + 1)}
                        key={`page ${page}`}
                        width={width}
                        pageNumber={page + 1} />
                ))}
            </Document>
        </Wrapper>
  );
}

const Wrapper = styled.div`
    width: 100%;
    overflow: hidden;
`;

export default PdfViewer;
